import React from 'react'

export const DetailRdv = ({ item }) => {
    return (
        <div>
            <div className="">
                <div className="bg-white p-3 rounded-lg border">
                    <div className="px-4 sm:px-0">
                        <h3 className="lg:text-lg text-2xl text-gray-900 font-bold">
                            Ticket N°{item?.abonnement?.eligibilite?.numeroTicket}
                        </h3>
                    </div>
                    <div className="mt-3 border-t border-gray-100">
                        <dl className="divide-y divide-gray-100">
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold text-gray-900">
                                    Client
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.client?.nomPrenoms}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Email
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.client?.email}
                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Contact client
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.client?.numero}
                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Numero avantage
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.numeroMtn}
                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Ville du client
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.domicile?.quartier?.commune?.designation}

                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Quartier
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.domicile?.quartier?.designation}

                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Status d'éligibilité
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.eligibilite?.ftthEligible === 'yes' ? 'Eligible' : 'Pas eligible'}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Forfait souhaité
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.abonnement?.forfait?.designation}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
            <div className="">
                <p className="my-4 font-bold text-lg">Prise de rendez-vous {item?.typeRdv?.toLowerCase()}</p>
                <div className="bg-white p-3 rounded-lg border">
                    <div className="">
                        <dl className="divide-y divide-gray-100">
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold text-gray-900">
                                    Date de rendez-vous
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item.dateRdv}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Créneau horaire
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item?.crenau?.heureDebut + " à " + item?.crenau?.heureFin}
                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Equipe en charge
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item?.equipe?.designation}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    )
}
